"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VideoSearchResultsConverter = void 0;
const PageableConverter_1 = require("../../common/model/PageableConverter");
const VideosConverter_1 = require("./VideosConverter");
class VideoSearchResultsConverter {
    static convert(entity) {
        const entityWithoutFacets = {
            ...entity,
            _embedded: {
                videos: entity._embedded.videos,
            },
        };
        const pageableVideos = PageableConverter_1.PageableConverter.convert(entityWithoutFacets, 'videos', VideosConverter_1.VideosConverter.convert);
        const convertFacets = (entity) => {
            if (entity) {
                return Object.keys(entity).map((key) => {
                    return {
                        name: entity[key].name || key,
                        id: entity[key].id || key,
                        hits: entity[key].hits,
                        score: entity[key].score,
                    };
                });
            }
            else {
                return [];
            }
        };
        return {
            ...pageableVideos,
            facets: {
                videoTypes: convertFacets(entity._embedded.facets?.videoTypes),
                subjects: convertFacets(entity._embedded.facets?.subjects),
                ageRanges: convertFacets(entity._embedded.facets?.ageRanges),
                bestForTags: convertFacets(entity._embedded.facets?.bestForTags),
                resourceTypes: convertFacets(entity._embedded.facets?.resourceTypes),
                channels: convertFacets(entity._embedded.facets?.channels),
                durations: convertFacets(entity._embedded.facets?.durations),
                topics: convertFacets(entity._embedded.facets?.topics),
                educationLevels: convertFacets(entity._embedded.facets?.educationLevels),
                languages: convertFacets(entity._embedded.facets?.languages),
                cefrLevels: convertFacets(entity._embedded.facets?.cefrLevels),
                videoSubtypes: convertFacets(entity._embedded.facets?.videoSubtypes),
            },
        };
    }
}
exports.VideoSearchResultsConverter = VideoSearchResultsConverter;
//# sourceMappingURL=VideoSearchResultsConverter.js.map